export const actionTypePrefix = '@@CommentEditor';
export const reduxKey = '@@CommentEditor';

//# sourceMappingURL=constants.js.map